


const BlogsLists = () => {
   return (
      <>
         <div className="bg-[#F9F9F9] p-3 pt-20">
            <div className="p-5 md:px-10">
               <div className="text-4xl font-light text-black">
                  Blogs
               </div>
               <p>Sharing my own thoughts</p>
            </div>
         </div>
         <div className="
         max-w-xl
         mx-auto
         rounded-md
         relative
         p-3
         overflow-hidden
         bg-[url('https://i.ibb.co/yB421Crq/198cc07d46354c42d6a3ae0cc5e29b29.jpg')]
         bg-cover
         bg-center
         bg-no-repeat
         border-none
         ">
         <div className="pt-20 z-20 text-black text-4xl pb-20 md:px-10 font-medium">
            
         </div>
         <div className="inset-0 z-0 absolute bg-gradient-to-t from-transparent via-[#f9f9f9c0] to-[#F9F9F9]"></div>
      </div>
      </>
   )
}

export default BlogsLists
